import * as React from 'react'

export const DriverAvatarIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2 1C1.4375 1 1 1.46875 1 2V14C1 14.5625 1.4375 15 2 15H10C10.5312 15 11 14.5625 11 14V2C11 1.46875 10.5312 1 10 1H2ZM0 2C0 0.90625 0.875 0 2 0H10C11.0938 0 12 0.90625 12 2V14C12 15.125 11.0938 16 10 16H2C0.875 16 0 15.125 0 14V2ZM7 7C7 6.46875 6.53125 6 6 6C5.4375 6 5 6.46875 5 7C5 7.5625 5.4375 8 6 8C6.53125 8 7 7.5625 7 7ZM4 7C4 6.3125 4.375 5.65625 5 5.28125C5.59375 4.9375 6.375 4.9375 7 5.28125C7.59375 5.65625 8 6.3125 8 7C8 7.71875 7.59375 8.375 7 8.75C6.375 9.09375 5.59375 9.09375 5 8.75C4.375 8.375 4 7.71875 4 7ZM4 2.5C4 2.25 4.21875 2 4.5 2H7.5C7.75 2 8 2.25 8 2.5C8 2.78125 7.75 3 7.5 3H4.5C4.21875 3 4 2.78125 4 2.5ZM3.5 12.5C3.5 12.7812 3.25 13 3 13C2.71875 13 2.5 12.7812 2.5 12.5C2.5 11.125 3.59375 10 5 10H7C8.375 10 9.5 11.125 9.5 12.5C9.5 12.7812 9.25 13 9 13C8.71875 13 8.5 12.7812 8.5 12.5C8.5 11.6875 7.8125 11 7 11H5C4.15625 11 3.5 11.6875 3.5 12.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
